import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Optimizer from "./pages/Optimizer";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";

// The admin dashboard still uses the Google OAuth session to gate access.
// The public Optimizer page is 100% anonymous — no auth calls, no paywall.
function AdminShell() {
  return (
    <AuthProvider>
      <AdminDashboard />
    </AuthProvider>
  );
}

function AuthCallbackShell() {
  return (
    <AuthProvider>
      <AuthCallback />
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Optimizer />} />
          <Route path="/admin" element={<AdminShell />} />
          <Route path="/auth/callback" element={<AuthCallbackShell />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton theme="dark" />
    </div>
  );
}

export default App;
